export default __webpack_public_path__ + "static/media/ies_Agenda.b84fdf49.png";